import React, { Component } from "react";

class CanvasAnimation extends Component {
  componentDidMount() {
    this.canvas = document.getElementById("canvas");
    this.ctx = this.canvas.getContext("2d");
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    this.stars = [];
    this.FPS = 60;
    this.x = 100;
    this.mouse = {
      x: 0,
      y: 0
    };

    this.initializeStars();
    this.tick();
  }

  initializeStars() {
    for (let i = 0; i < this.x; i++) {
      this.stars.push({
        x: Math.random() * this.canvas.width,
        y: Math.random() * this.canvas.height,
        radius: Math.random() * 1 + 2,
        vx: Math.floor(Math.random() * 50) - 25,
        vy: Math.floor(Math.random() * 50) - 25
      });
    }
  }

  draw() {
    const { ctx, canvas, stars, mouse } = this;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.globalCompositeOperation = "lighter";

    for (let i = 0, x = stars.length; i < x; i++) {
      const s = stars[i];

      ctx.fillStyle = "#006400";
      ctx.beginPath();
      ctx.arc(s.x, s.y, s.radius, 0, 2 * Math.PI);
      ctx.fill();
      ctx.fillStyle = "#006400";
      ctx.stroke();
    }

    ctx.beginPath();
    for (let i = 0, x = stars.length; i < x; i++) {
      const starI = stars[i];
      ctx.moveTo(starI.x, starI.y);
      if (this.distance(mouse, starI) < 150) ctx.lineTo(mouse.x, mouse.y);
      for (let j = 0, x = stars.length; j < x; j++) {
        const starII = stars[j];
        if (this.distance(starI, starII) < 150) {
          ctx.lineTo(starII.x, starII.y);
        }
      }
    }
    ctx.lineWidth = 0.05;
    ctx.strokeStyle = "#006400";
    ctx.stroke();
  }

  distance(point1, point2) {
    let xs = 0;
    let ys = 0;

    xs = point2.x - point1.x;
    xs = xs * xs;

    ys = point2.y - point1.y;
    ys = ys * ys;

    return Math.sqrt(xs + ys);
  }

  update() {
    const { stars, canvas } = this;

    for (let i = 0, x = stars.length; i < x; i++) {
      const s = stars[i];

      s.x += s.vx / this.FPS;
      s.y += s.vy / this.FPS;

      if (s.x < 0 || s.x > canvas.width) s.vx = -s.vx;
      if (s.y < 0 || s.y > canvas.height) s.vy = -s.vy;
    }
  }

  handleMouseMove = (e) => {
    this.mouse.x = e.clientX;
    this.mouse.y = e.clientY;
  };

  tick = () => {
    this.draw();
    this.update();
    requestAnimationFrame(this.tick);
  };

  render() {
    return <canvas id="canvas" onMouseMove={this.handleMouseMove}></canvas>;
  }
}

export default CanvasAnimation;
